module.exports = __webpack_public_path__ + "media/src/images/top_covers/May_01-f3de7bde2f7ac16afa161dd47cfc441a.png";